class PurchasingAccountsService {
  constructor(httpDim, config) {
    this.httpDim = httpDim;
    this.config = config;
  }

  getOrgHierarchy(customerId) {
    const url = `${this.config.apiRoot}/customers/${customerId}/orgs/hierarchy?flattened=true`;
    return this.httpDim.get(url, {});
  }

  getPurchasingAccounts(orgXid) {
    const url = `${this.config.apiRoot}/customers/${orgXid}/purchasingAccounts`;
    return this.httpDim.get(url, {});
  }

  getPurchasingAccountsByCustomerId(customerId) {
    const url = `${this.config.apiRoot}/purchasingAccounts/${customerId}`;
    return this.httpDim.get(url, {});
  }

}

PurchasingAccountsService.$inject = ['httpDim', 'config'];

export default PurchasingAccountsService;



// WEBPACK FOOTER //
// ./app/components/purchasingAccounts/purchasingAccounts.service.js